import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  active_img,
  deactive_img,
  delete_icon,
  edit_icon,
  eye_icon,
  password_icon,
  search_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import { admin_list } from "../../screens/redux/api/dummyJson";
import { useLazyTotalLocationsListQuery, usePropertyVerificationMutation } from "../../screens/redux/api/api";
import moment from "moment";
import CustomSearchSelect from "../Searchbox/CustomSearch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "react-bootstrap";

const PropertRejected = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [list, setList] = useState([]);
  const [fromdate, setFromDate] = useState()
  const [toDate, setToDate] = useState()
  const [city, setCity] = useState('')
  const [search, setSearch] = useState('')
  const [type, setType] = useState('')
  const [status, setStatus] = useState('');
  const [visible, setVisible] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [cities, setCities] = useState([])
  const [locationLoader, setLocationLoader] = useState(false);
  const [count, setCount] = useState();
  const [selectedCityId, setSelectedCityId] = useState('')

  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

  //RTK
  const [getListApi] = usePropertyVerificationMutation()
  const [getCityApi] = useLazyTotalLocationsListQuery()

  const getList = (fromdate, toDate, city, search, type, status, page) => {
    const formdata = new FormData();
    formdata.append("page", page);
    formdata.append("row", 10);
    formdata.append("status[0]", 3);
    if (fromdate && toDate) {
      formdata.append("from_date", moment(fromdate).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    }
    if (search) formdata.append("search", search);
    if (city) formdata.append("city", city);
    formdata.append("type", 'all');
    formdata.append('verification_status[0]', 3);
    formdata.append('document_status[0]', 1)
    formdata.append('document_status[1]', 3)
    formdata.append('list_type', "rejected");


    setFromDate(fromdate)
    setToDate(toDate)
    setCity(city)
    setType(type)
    setStatus(status)
    setSearch(search)

    getListApi(formdata)
      .unwrap()
      .then((res) => {
        let temp = []
        res?.data?.map((item, ind) => {
          let obj = { ...item }
          obj.current_page = res?.pagination?.current_page
          temp.push(obj)
        })
        setList(temp);
        setCount(res?.pagination?.total)
        setPagecount(res?.pagination)
        // setList(res?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  const getLocations = () => {
    setLocationLoader(true)
    getCityApi()
      .unwrap()
      .then((res) => {
        console.log(res)
        let temp = res?.data?.filter((item) => item?.type == 3)
        setCities(temp)
        setLocationLoader(false)
      }).catch((err) => {
        console.error(err)
      })
  }




  useEffect(() => {
    getList(fromdate, toDate, city, search, type, status, pageno);
    getLocations()
  }, [pageno]);


  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Property Id",
        accessor: "property_id",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() =>
            navigate("/property-rej-view", {
              state: { data: row.original },
            })
          }>{value}</p>
          </div>
        },
      },
      {
        Header: "Property Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() =>
            navigate("/property-rej-view", {
              state: { data: row.original },
            })
          }>{value}</p>
          </div>
        },
      },
      {
        Header: "Owner Name",
        accessor: "owner",
        Cell: ({ value, row }) => {
          return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner_id } })}>{value?.name}</p> </div>
        },
      },
      {
        Header: "Type",
        accessor: "property_type",
        Cell: ({ value, row }) => {
          return <p>{value == 1 ? "Room" : value == 2 ? "Individual" : ""}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value?.name}</p>;
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-VIEW-PROPERTY VERIFICATION') &&
                  <button
                    onClick={() =>
                      navigate("/property-rej-view", {
                        state: { data: row.original },
                      })
                    }
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );



  return (
    <div className="dashRightView home_section">
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
        Property Rejected ({count})
      </h2>
      <div className="d-flex ac-jb mt-4">
        <div className="d-flex ac-js gap-2">
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            From Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={fromdate}
              onChange={(e) => getList(
                e,
                toDate,
                city,
                search,
                type,
                status,
                1,
              )}
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="From Date"
              type="date"
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary text-nowrap">
            To Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={toDate}
              onChange={(e) => getList(
                fromdate,
                e,
                city,
                search,
                type,
                status,
                1,
              )}
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="To Date"
              type="date"
            />
          </div>
          <CustomSearchSelect
            options={cities}
            value={selectedCityId}
            locationLoader={locationLoader}
            onChange={(value) => {
              setSelectedCityId(value);
              getList(
                fromdate,
                toDate,
                value,
                search,
                type,
                status,
                pageno
              );
            }}
            placeholder="Select City"
            width="200px"
          />


          <input
            type="text"
            value={search}
            onChange={(e) => {
              getList(
                fromdate,
                toDate,
                city,
                e.target.value,
                type,
                status,
                pageno
              );
            }}
            className="input-pop-new ps-2 w-15"
            placeholder="search..."
          />

        </div>
      </div>

      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />

      {loading && (
        <div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
          <Spinner animation="border" className="primary1" />
        </div>)}
    </div>
  );
};


export default PropertRejected;